import { BotInfo, BrowserInfo, NodeInfo, ReactNativeInfo, SearchBotDeviceInfo } from 'detect-browser';

function generateDevice(browser: BrowserInfo | BotInfo | SearchBotDeviceInfo | NodeInfo | ReactNativeInfo | null) {
  return {
    browser: {
      name: browser?.name,
      userAgent: navigator.userAgent,
      version: browser?.version,
    },
    screen: {
      width: window.innerWidth,
      height: window.innerHeight,
      hasTouch: window.matchMedia('(pointer: coarse)').matches,
    },
  };
}

export { generateDevice };
